import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SettingFilledSvg from "@ant-design/icons-svg/es/asn/SettingFilled";
import AntdIcon from "../components/AntdIcon";
var SettingFilled = function SettingFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SettingFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SettingFilled.displayName = 'SettingFilled';
}
export default /*#__PURE__*/React.forwardRef(SettingFilled);